import React from 'react';
import PublicRegistration from './containers/components/publicRegistration';
import SiteIndexToogle from 'pages/signinSettings/containers/components/siteIndexToogle';

function SignInSettings() {
  return (
    <div className="form-container profile-form p-0">
      <h2 className="mb-4 pb-2">Access & Visibility</h2>
      <PublicRegistration />
      <SiteIndexToogle />
    </div>
  );
}

export default SignInSettings;
